import { render } from "./PositionDocumentList.vue?vue&type=template&id=342bbfce"
import script from "./PositionDocumentList.vue?vue&type=script&lang=ts"
export * from "./PositionDocumentList.vue?vue&type=script&lang=ts"
script.render = render

export default script